import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/imgs/seadust/awards/TC.jpg")